// extracted by mini-css-extract-plugin
module.exports = {"accordion-item__content":"accordion_accordion-item__content__1TfIT","accordion-item__content--active":"accordion_accordion-item__content--active__1CdUu"};